import React from 'react';
import Svg, { Path, G } from 'react-native-svg';
import { useTheme } from 'styled-components/native';
import { IconProps } from './types';

const NutritionProgramIcon = ({ color }: IconProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Path
        d="M23.998 19a1 1 0 01-1 1v1a1 1 0 11-2 0v-4a1 1 0 112 0v1a1 1 0 011 1zm-16-3a1 1 0 00-1 1v1a1 1 0 100 2v1a1 1 0 102 0v-4a1 1 0 00-1-1zm11-2a1 1 0 00-1 1v3h-6v-3a1 1 0 10-2 0v8a1 1 0 102 0v-3h6v3a1 1 0 102 0v-8a1 1 0 00-1-1zm-14.563.568c-1.48-.717-2.437-2.314-2.437-4.077-.066-2.297 1.784-4.526 4.11-4.492h4.78c2.33-.032 4.176 2.194 4.11 4.5a4.683 4.683 0 01-.98 2.883 1 1 0 101.574 1.235 6.69 6.69 0 001.404-4.11c.082-3.183-2.39-6.242-5.579-6.481.121-.092.246-.178.357-.288.758-.758 1.104-1.853 1.213-2.643A.96.96 0 0011.901.009c-.79.109-1.885.455-2.643 1.213-.29.29-.502.627-.674.973A8.79 8.79 0 007.875.52a1 1 0 00-1.755.959 6.94 6.94 0 01.806 2.52h-.819C2.704 3.938-.097 7.134-.002 10.5c0 2.516 1.398 4.819 3.563 5.869a1.002 1.002 0 001.336-.464 1 1 0 00-.462-1.336z"
        fill="#EC6338"
      />
    </Svg>
  );
};

export default NutritionProgramIcon;